@for (summaryItem of summaryItems$ | async; track summaryItem; let i = $index) {
  <div class="question-container">
    <div class="header" [ngClass]="{ error: summaryItem.errors.length > 0 }">
      <div class="slide-number">{{ i + 1 }}</div>
      <div class="flexibility" [ngClass]="summaryItem.flexibility">{{ summaryItem.flexibility }}</div>
      <ion-button
        class="edit secondaryTextLink"
        type="button"
        fill="clear"
        (click)="switchSlide.emit(summaryItem.slideNumber)">
        Edit response
      </ion-button>
    </div>
    <div class="question">{{ summaryItem.question }}</div>
    @if (summaryItem.errors.length === 0) {
      @if (summaryItem.renderAs === 'text') {
        <div class="text-value">
          {{ summaryItem.textValue }}
        </div>
      }
      @if (summaryItem.renderAs === 'list') {
        <div class="multi-select">
          @for (listItem of summaryItem.listValue.items; track listItem) {
            <div class="option selected">
              <span>{{ listItem.legend }}</span>
            </div>
          }
        </div>
      }
    } @else {
      <div class="error-value">A valid response is required.</div>
    }
  </div>
}
